import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/admin/api/roles';

export const updateRole = async ({ roleKey, payload }) =>
  await ajax('PUT', `${rootUrl}/${roleKey}`, JSON.stringify(payload));

export const deletePdfFileFromRole = async ({ payload }) =>
  await ajax('DELETE', `${rootUrl}/delete-pdf-file`, payload);
